import { useFeeCalculatorPortfolioSetup } from "@hooks/useFeeCalculatorPortfolioSetup";
import { FeeCalculatorPortfolioLevel } from "@models/platform-analysis/enums/fee/portfolioLevel";
import { AnalysisVariable } from "@models/platform-analysis/enums/variableName";
import { RootState } from "@redux/store";
import { memo, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { portfolioInvestmentTypeCheckboxValidation } from "../../rendered-fields/portfolio-setup/utils";

export const InvestmentSelectionPortfolioLevelTracker = memo(
  ({
    variableName,
    onNotExistsWeightChange,
  }: {
    variableName: AnalysisVariable;
    onNotExistsWeightChange: (forceEnable: boolean) => void;
  }) => {
    const { portfolios, portfolioSetups } = useFeeCalculatorPortfolioSetup();
    const portfolioLevel = useSelector(
      (state: RootState) => state.platformAnalysis?.ui?.portfolioLevel,
    );

    const notExistWeightRef = useRef<boolean>();

    const notExistingPortfolioWeight =
      !portfolioLevel || portfolioLevel === FeeCalculatorPortfolioLevel.No
        ? true
        : portfolioInvestmentTypeCheckboxValidation(
            variableName,
            portfolioLevel,
            portfolios,
            portfolioSetups,
            true,
          );

    useEffect(() => {
      if (notExistWeightRef.current === notExistingPortfolioWeight) return;
      notExistWeightRef.current = notExistingPortfolioWeight;
      onNotExistsWeightChange(!notExistingPortfolioWeight);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [portfolioLevel, notExistingPortfolioWeight]);

    return <></>;
  },
);
